/**
 * fiscalYear năm tài chính
 * Mặc định ngày bắt đầu là thứ 2
 */

import { MSEnum } from '@/common/enumeration';

let Period = MSEnum.Period;

class DateRange {
	constructor() {}

	/**
	 * Xác định quý
	 * @param {*} month
	 */
	caculQuarterByMonth(month) {
		//Xác định quý
		if (isNaN(month)) return;
		return Math.floor(month / 3) + 1;
	}

	/**
	 * Ngày hiện tại
	 */
	getThisDay() {
		let d = new Date();
		return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0);
	}

	/**
	 * Tính ngày bắt đầu của tháng (1...12)
	 */
	getFromDateMonth(month) {
		let dateNow = new Date();
		return new Date(dateNow.getFullYear(), month - 1, 1);
	}

	/**
	 * Tính ngày kết thúc của tháng (1....12)
	 */
	getToDateMonth(month) {
		const currentYear = new Date().getFullYear(),
			daysInMonth =
				32 - new Date(currentYear, month - 1, 32, 0, 0, 0).getDate();
		return new Date(currentYear, month - 1, daysInMonth, 0, 0, 0);
	}

	/**
	 * Quý này
	 */
	getThisQuarter() {
		let date = new Date();
		let currenMonth = date.getMonth(),
			currentQuater = this.caculQuarterByMonth(currenMonth),
			currentYear = date.getFullYear();
		let range = {};
		range.fromDate = this.fromQuarter(currentQuater, currentYear);
		range.toDate = this.toQuarter(currentQuater, currentYear);
		return range;
	}

	/**
	 * Quý sau
	 */
	getNextQuarter() {
		let date = new Date();
		let currenMonth = date.getMonth(),
			currentQuater = this.caculQuarterByMonth(currenMonth) + 1,
			currentYear = date.getFullYear(),
			range = {};

		range.fromDate = this.fromQuarter(currentQuater, currentYear);
		range.toDate = this.toQuarter(currentQuater, currentYear);
		return range;
	}

	/**
	 * Quý trước
	 */
	getLastQuarter() {
		let date = new Date();
		let currenMonth = date.getMonth(),
			currentQuater = this.caculQuarterByMonth(currenMonth) - 1,
			currentYear = date.getFullYear(),
			range = {};

		range.fromDate = this.fromQuarter(currentQuater, currentYear);
		range.toDate = this.toQuarter(currentQuater, currentYear);
		return range;
	}

	/**
	 * Tính hôm qua
	 */
	getYesterday() {
		let dte = new Date();
		dte.addDays(-1);
		return dte;
	}

	/**
	 * Tính ngày mai
	 */
	getTomorrow() {
		let dte = new Date();
		dte.addDays(1);
		return dte;
	}

	/**
	 * Tính tuần này
	 */
	getThisWeek() {
		//Tính ngày hiện tại là thứ mấy
		let date = new Date();
		let currentYear = date.getFullYear(),
			currenMonth = date.getMonth(),
			currentDay = date.getDate();
		let day = date.getDay();
		let x = day == 0 ? day + 7 - 1 : day - 1;
		let range = {};
		range.fromDate = new Date(
			currentYear,
			currenMonth,
			currentDay - x,
			0,
			0,
			0
		);
		range.toDate = new Date(
			currentYear,
			currenMonth,
			currentDay - x + 6,
			0,
			0,
			0
		);
		return range;
	}

	/**
	 * Tính tuần trước
	 */
	getLastWeek() {
		let date = new Date();
		let currentYear = date.getFullYear(),
			currenMonth = date.getMonth(),
			currentDay = date.getDate();
		let day = date.getDay();
		let x = day == 0 ? day + 7 - 1 : day - 1;
		let range = {};
		range.fromDate = new Date(
			currentYear,
			currenMonth,
			currentDay - x - 7,
			0,
			0,
			0
		);
		range.toDate = new Date(
			currentYear,
			currenMonth,
			currentDay - x - 1,
			0,
			0,
			0
		);
		return range;
	}

	/**
	 * Tuần tới
	 */
	getNextWeek() {
		let date = new Date();
		let currentYear = date.getFullYear(),
			currenMonth = date.getMonth(),
			currentDay = date.getDate();
		let day = date.getDay();
		let x = day == 0 ? day + 6 : day - 1;
		let range = {};
		range.fromDate = new Date(
			currentYear,
			currenMonth,
			currentDay - x + 7,
			0,
			0,
			0
		);
		range.toDate = new Date(
			currentYear,
			currenMonth,
			currentDay - x + 13,
			0,
			0,
			0
		);
		return range;
	}

	/**
	 * Tháng này
	 *
	 */
	getThisMonth() {
		let date = new Date();
		let currentYear = date.getFullYear(),
			currenMonth = date.getMonth(),
			currentDay = date.getDate(),
			daysOfMonth = 32 - new Date(currentYear, currenMonth, 32).getDate();
		let range = {};
		range.fromDate = new Date(currentYear, currenMonth, 1, 0, 0, 0);
		range.toDate = new Date(currentYear, currenMonth, daysOfMonth, 0, 0, 0);
		return range;
	}

	/**
	 * Tháng sau
	 */
	getLastMonth() {
		let date = new Date();
		let currentYear = date.getFullYear(),
			currenMonth = date.getMonth(),
			currentDay = date.getDate(),
			daysOfMonth =
				32 - new Date(currentYear, currenMonth - 1, 32).getDate();
		let range = {};
		range.fromDate = new Date(currentYear, currenMonth - 1, 1);
		range.toDate = new Date(currentYear, currenMonth - 1, daysOfMonth);
		return range;
	}

	/**
	 * Tính tháng tới
	 */
	getNextMonth() {
		let date = new Date();
		let currentYear = date.getFullYear(),
			currenMonth = date.getMonth(),
			currentDay = date.getDate();
		let range = {};
		range.fromDate = new Date(currentYear, currenMonth + 1, 1);
		range.toDate = new Date(
			currentYear,
			currenMonth + 1,
			32 - new Date(currentYear, currenMonth + 1, 32).getDate()
		);
		return range;
	}

	/**
	 * Tính sáu tháng cuối năm +Từ ngày đầu tiên + 6 tháng nữa
	 */
	getSixLastMonth() {
		let currentYear = new Date().getFullYear(),
			startMonth = new Date(new Date(currentYear, 0, 1)).getMonth(),
			daysOfMonth =
				32 - new Date(currentYear, startMonth + 11, 32).getDate();
		let range = {};
		range.fromDate = new Date(currentYear, startMonth + 6, 1, 0, 0, 0);
		range.toDate = new Date(currentYear, startMonth + 11, daysOfMonth);
		return range;
	}

	/**
	 * Tính sáu tháng đầu  năm
	 */
	getSixFirstMonth() {
		let currentYear = new Date().getFullYear(),
			currenMonth = new Date(new Date(currentYear, 0, 1)).getMonth(),
			daysOfMonth =
				32 - new Date(currentYear, currenMonth + 5, 32).getDate();
		let range = {};
		range.fromDate = new Date(currentYear, currenMonth, 1, 0, 0, 0);
		range.toDate = new Date(currentYear, currenMonth + 5, daysOfMonth);
		return range;
	}

	/**
	 * Tính năm  trước
	 */
	getLastYear() {
		let currentYear = new Date().getFullYear(),
			currenMonth = new Date(new Date(currentYear, 0, 1)).getMonth(),
			daysOfMonth =
				32 - new Date(currentYear - 1, currenMonth + 11, 32).getDate();
		let range = {};
		range.fromDate = new Date(currentYear - 1, currenMonth, 1, 0, 0, 0);
		range.toDate = new Date(currentYear - 1, currenMonth + 11, daysOfMonth);

		return range;
	}

	/**
	 * Năm sau
	 */
	getNextYear() {
		let currentYear = new Date().getFullYear(),
			currenMonth = new Date(new Date(currentYear, 0, 1)).getMonth(),
			daysOfMonth =
				32 - new Date(currentYear + 1, currenMonth + 11, 32).getDate();
		let range = {};
		range.fromDate = new Date(currentYear + 1, currenMonth, 1, 0, 0, 0);
		range.toDate = new Date(currentYear + 1, currenMonth + 11, daysOfMonth);

		return range;
	}

	// /**
	//  * Kiểm tra xem ngày hạch toán của hệ thống so với ngày bắt đầu của năm tài chính
	//  * true<==> Ngày hoạch toán nhỏ hơn ngày bắt đầu Năm tài chính
	//  */
	// checkFiscalYear() {
	// 	let postedDate = new Date(2019,.getMonth(),.getDate(),0,0,0).getTime() / 1000;
	// 	let startDate =new Date(2019,this.FiscalFromDate.getMonth(),this.FiscalFromDate.getDate(),0,0,0).getTime() / 1000;
	// 	return postedDate <  startDate;
	// }
	/**
	 * Năm nay
	 */
	getThisYear() {
		let range = {};
		let currentYear = new Date().getFullYear(),
			currenMonth = new Date(new Date(currentYear, 0, 1)).getMonth(),
			currentDay = new Date(new Date(currentYear, 0, 1)).getDate(),
			daysOfMonth =
				32 - new Date(currentYear, currenMonth + 11, 32).getDate();
		range.fromDate = new Date(currentYear, currenMonth, 1, 0, 0, 0);
		// range.fromDate = new Date(currentYear,0,1);
		range.toDate = new Date(
			currentYear,
			currenMonth + 11,
			daysOfMonth,
			0,
			0,
			0
		);

		return range;
	}

	/**
	 * Cách đây 3 năm
	 */
	getThreeLastWeek() {
		// let range={};
		// range.fromDate = new Date(this.FiscalFromDate.addYears(-3));
		// range.toDate = new Date(this.FiscalFromDate.addYears(-2).addDays(-1));
		// return range;
		let currentYear = new Date().getFullYear(),
			currenMonth = new Date(new Date(currentYear, 0, 1)).getMonth(),
			currentDay = new Date(new Date(currentYear, 0, 1)).getDate(),
			daysOfMonth =
				32 - new Date(currentYear - 3, currenMonth + 11, 32).getDate();
		let range = {};
		range.fromDate = new Date(currentYear - 3, currenMonth, 1, 0, 0, 0);
		range.toDate = new Date(currentYear - 3, currenMonth + 11, daysOfMonth);
		return range;
	}

	/**
	 * Đầu tuần với hiện tại
	 */
	getFirstWeekToPresent() {
		//Tính ngày hiện tại là thứ mấy
		let date = new Date();
		let currentYear = date.getFullYear(),
			currenMonth = date.getMonth(),
			currentDay = date.getDate();
		let day = date.getDay();
		let x = day == 0 ? day + 7 - 1 : day - 1;
		let range = {};
		range.fromDate = new Date(
			currentYear,
			currenMonth,
			currentDay - x,
			0,
			0,
			0
		);
		range.toDate = new Date(currentYear, currenMonth, currentDay, 0, 0, 0);
		return range;
	}

	/**
	 * Đầu quý đến hiện tại
	 */
	getFirstQuarterToPresent() {
		//Tính quý này là quý nào
		let date = new Date();
		let currenMonth = date.getMonth(),
			currentQuater = this.caculQuarterByMonth(currenMonth);
		let range = {};
		range.fromDate = this.fromQuarter(currentQuater, date.getFullYear());
		range.toDate = date;
		return range;
	}

	/**
	 * Đầu tháng đến hiện tại
	 */
	getFirstMonthToPresent() {
		let date = new Date();
		let currentYear = date.getFullYear(),
			currenMonth = date.getMonth(),
			currentDay = date.getDate();
		let range = {};
		range.fromDate = new Date(currentYear, currenMonth, 1, 0, 0, 0);
		range.toDate = new Date(currentYear, currenMonth + 1, 1, 0, 0, 0);
		return range;
	}

	/**
	 * Đầu năm đến hiện tại
	 */
	getFirstYearToPresent() {
		let currentYear = new Date().getFullYear(),
			currenMonth = new Date(new Date(currentYear, 0, 1)).getMonth(),
			currentDay = new Date(new Date(currentYear, 0, 1)).getDate();
		let range = {};
		range.fromDate = new Date(currentYear, currenMonth, 1, 0, 0, 0);
		range.toDate = new Date(currentYear + 1, currenMonth, 1, 0, 0, 0);
		return range;
	}

	/**
	 * Ngày bắt đầu của quý
	 * @param {*} quater=tên quý +offset
	 */
	fromQuarter(quater, year) {
		//tính ngày bắt đầu quý
		let month = (quater - 1) * 3 + 1;
		let fromDate = new Date(year, month - 1, 1);
		return fromDate;
	}

	/**
	 * Ngày kết thúc Quý
	 * @param {*} quater=tên quý +offset:Ví dụ quý I nhưng ngày final lại là 1/4 => Thực tế là quý 2
	 */
	toQuarter(quater, year) {
		//Ngày kết thuc của quý
		let month = quater * 3;
		const daysInMonth = 32 - new Date(year, month - 1, 32).getDate();
		let toDate = new Date(year, month - 1, daysInMonth);
		return toDate;
	}

	/***
	 * TThuyen Hàm tính Ngày tháng
	 * @return {Object} trả về range {fromDate: , toDate: }
	 */
	caculateRangeFromPeriod(period, innerFromDate, innerToDate) {
		let me = this,
			range,
			fromDate,
			toDate;
		switch (period) {
			case Period.January:
			case Period.February:
			case Period.March:
			case Period.April:
			case Period.May:
			case Period.June:
			case Period.July:
			case Period.August:
			case Period.September:
			case Period.October:
			case Period.November:
			case Period.December:
				fromDate = me.getFromDateMonth(period);
				toDate = me.getToDateMonth(period);
				break;
			case Period.FiscalI:
			case Period.FiscalII:
			case Period.FiscalIII:
			case Period.FiscalIV: {
				let offsetQuarter = me.caculQuarterByMonth(0) - 1,
					fiscal = period / 100 + offsetQuarter;
				fromDate = me.fromQuarter(fiscal, new Date().getFullYear());
				toDate = me.toQuarter(fiscal, new Date().getFullYear());
				break;
			}
			case Period.ThisDay:
				fromDate = toDate = me.getThisDay();
				// toDate = me.getThisDay();
				break;
			case Period.Yesterday: {
				fromDate = me.getYesterday();
				toDate = me.getYesterday();
				break;
			}
			case Period.Tomorrow: {
				fromDate = me.getTomorrow();
				toDate = me.getTomorrow();
				break;
			}
			case Period.ThisWeek: {
				range = me.getThisWeek();

				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.LastWeek: {
				range = me.getLastWeek();

				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.NextWeek: {
				range = me.getNextWeek();

				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.ThisMonth: {
				range = me.getThisMonth();

				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.LastMonth: {
				range = me.getLastMonth();

				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.NextMonth: {
				range = me.getNextMonth();
				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.ThisQuarter: {
				range = me.getThisQuarter();
				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.LastQuarter: {
				range = me.getLastQuarter();
				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.NextQuarter: {
				range = me.getNextQuarter();
				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.SixLastMonth: {
				range = me.getSixLastMonth();
				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.SixFirstMonth: {
				range = me.getSixFirstMonth();
				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.ThisYear: {
				range = me.getThisYear();
				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.LastYear: {
				range = me.getLastYear();
				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.NextYear: {
				range = me.getNextYear();
				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			// case Period.ThreeLastYear: {
			// 	range = me.getThreeLastWeek();
			// 	fromDate = range.fromDate;
			// 	toDate = range.toDate;
			// 	break;
			// }
			case Period.FirstWeekToPresent: {
				range = me.getFirstWeekToPresent();
				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.FirstQuarterToPresent: {
				range = me.getFirstQuarterToPresent();
				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.FirstYearToPresent: {
				range = me.getFirstYearToPresent();
				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			case Period.FirstMonthToPresent: {
				range = me.getFirstMonthToPresent();
				fromDate = range.fromDate;
				toDate = range.toDate;
				break;
			}
			default:
				fromDate = innerFromDate;
				toDate = innerToDate;
				break;
		}

		return {
			fromDate: fromDate,
			toDate: toDate
		};
	}

	/**
	 * Tính ra kỳ theo từ ngày và đến ngày
	 * @param {Date} fromDate Từ ngày
	 * @param {Date} toDate Đến ngày
	 * @returns {number} Giá trị của kỳ (theo MSEnum)
	 * @author pcminh 24.04.2020
	 */
	caculatePeriodFromRange(fromDate, toDate) {
		let period = MSEnum.Period.Custom;
		for (let i = 0; i < Object.keys(MSEnum.Period).length; i++) {
			const key = Object.keys(MSEnum.Period)[i];
			let range = this.caculateRangeFromPeriod(MSEnum.Period[key]);
			if (
				new Date(fromDate).toDateString() ==
					new Date(range.fromDate).toDateString() &&
				new Date(toDate).toDateString() ==
					new Date(range.toDate).toDateString()
			) {
				period = MSEnum.Period[key];
				break;
			}
		}
		return period;
	}
}

export default new DateRange();
